import { observer } from 'mobx-react';
import { Button } from '~components/button';
import SparkleIcon from '../../../../icons/Sparkle.svg?react';
import { useAuthStore } from '~contexts/mobx';
import { useAgentChat } from '~contexts/agent-chat';

/** Opens the agent chat overlay. Gated to match the API's `group: 'Admin'` agent
 * routes, which Managers also pass (see hasRequiredGroup in ctd-web-api). */
export const AskAIButton = observer(() => {
    const authStore = useAuthStore();
    const { open } = useAgentChat();

    if (!authStore.hasManagementAccess) {
        return null;
    }

    return (
        <Button
            variant="primary"
            icon={<SparkleIcon className="anticon" />}
            onClick={open}
        >
            Ask AI
        </Button>
    );
});
